import type { JSX } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';

export function OutletWithContext(): JSX.Element {
  const outletContext = useOutletContext();
  return <Outlet context={outletContext} />;
}
